import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProofBar from "@/components/ProofBar";
import CeShopFeature from "@/components/CeShopFeature";
import ImplementationPaths from "@/components/ImplementationPaths";
import ProductsBuilt from "@/components/ProductsBuilt";
import AcademyClasses from "@/components/AcademyClasses";
import SpeakingSection from "@/components/SpeakingSection";
import OtherWays from "@/components/OtherWays";
import LegacySection from "@/components/LegacySection";
import GlobalCTA from "@/components/GlobalCTA";
import Footer from "@/components/Footer";
import PageSEO from "@/components/PageSEO";
import { personSchema, organizationSchema, breadcrumb } from "@/lib/schemas";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Marquetta Bryant | Broker, Mortgage Advisor, AI Builder"
        ogTitle="Marquetta Bryant | Real Estate Broker, Mortgage Advisor & AI Systems Builder"
        description="Real estate broker, Mortgage Advisor, and AI systems builder helping real estate professionals replace scattered tools with systems they own."
        canonical="https://marquettabryant.com/"
        jsonLd={[personSchema, organizationSchema, breadcrumb([{ name: "Home", path: "/" }])]}
      />
      <Header />
      <main id="main-content">
        <Hero />
        <ProofBar />
        <ImplementationPaths />
        <ProductsBuilt />
        <AcademyClasses />
        <SpeakingSection />
        <CeShopFeature />
        <OtherWays />
        <LegacySection />
        <GlobalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
